<template>
  <v-card class="pa-6">
    <ModalPercentualRateio
      :selectedItem="selectedService"
      :dialog="dialogConsultaPercentual"
      @update:dialog="dialogConsultaPercentual = $event"
    />
    <ModalForm
      ref="mainModal"
      :labelBtn="labelBtn"
      :dialog.sync="dialog"
      :selectedItem="selectedService"
    />

    <BaseDataTable
      :headers="headers"
      :items="itemsServices"
      :items-per-page="8"
      :currentPage="currentPage"
      :lastPage="lastPage"
      :loading="loading"
      :paginate="true"
      @pageChange="fetchServices({ ...filter, page: $event })"
      :footer-props="{ itemsPerPageText: 'Linhas por página' }"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="7" lg="7" class="d-flex align-center pa-0">
          </v-col>
          <v-col cols="12" md="5" lg="5" class="d-flex align-start pa-0">
            <v-btn
              height="55px"
              dark
              class="mr-2 elevation-0"
              color="#313a46"
              v-can:permission="'servico-prestado#store'"
              @click="openModal"
            >
              <v-icon small class="mr-3">mdi-plus-circle</v-icon>adicionar
            </v-btn>
            <MenuFilterSearchTable
              :placeholder="'Buscar por serviço ou cod. contabilização'"
              :textQuery="'descricao'"
              :codQuery="'cod_contabilizacao_padrao'"
              @textValue="updateFilter($event)"
            />
          </v-col>
        </v-row>
      </template>

      <!-- ---------------- header ---------------- -->
      <!-- <template v-slot:header.descricao="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            localFilter="api"
            :label="`${header.text}`"
            :query="'descricao'"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template> -->
      <template v-slot:header.cod_tributacao_municipio="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            localFilter="api"
            :label="`${header.text}`"
            :query="'cod_tributacao_municipio'"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template>

      <template v-slot:header.cod_contabilizacao_padrao="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            localFilter="api"
            :label="`${header.text}`"
            :query="'cod_contabilizacao_padrao'"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template>

      <!-- ---------------- items ---------------- -->
      <template v-slot:item.descricao="{ item }">
        <v-tooltip
          max-width="250px"
          class="ml-6"
          v-if="item.descricao.length > 70"
          top
        >
          <template v-slot:activator="{ on }">
            <p class="text-left" v-on="on">
              {{ item.descricao | limitaDescricao }}
            </p>
          </template>
          <span>{{ item.descricao | formataDescricao }}</span>
        </v-tooltip>
        <span class="d-block text-left" v-else>{{
          item.descricao | limitaDescricao
        }}</span>
      </template>

      <template v-slot:item.cod_nat_rend_pj="{ item }">
        {{ item.cod_nat_rend_pj ? item.cod_nat_rend_pj : "Não informado" }}
      </template>

      <template v-slot:item.action="{ item }">
        <v-tooltip v-can:permission="'servico-prestado#list-all'" top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="openConsultaPercentual(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>Consultar percentual de rateio padrão</span>
        </v-tooltip>
        <v-btn
          v-can:permission="'servico-prestado#update'"
          icon
          @click="openModalEdit(item)"
        >
          <v-icon color="warning">mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          v-can:permission="'servico-prestado#delete'"
          icon
          @click="deleteService(item)"
        >
          <v-icon color="error">mdi-trash-can</v-icon>
        </v-btn>

      </template>

      <template v-slot:activator>
        <div class="text-center"></div>
      </template>
    </BaseDataTable>
    <router-view></router-view>
  </v-card>
</template>
<script>
import toast from "@/commom/toast";
import MenuFilter from "@/components/MenuFilter.vue";
import MenuFilterSearchTable from "@/components/MenuFilterSearchTable.vue";
import servicosPrestados from "@/services/http/rpa/ServicosPrestados";
import { permissions } from "@/store/permissionsStore";
import toTitle from "@/util/util";
import BaseDataTable from "../../../../components/BaseDataTable.vue";
import ModalForm from "./ModalForm.vue";
import ModalPercentualRateio from "./ModalPercentualRateio.vue";
// eslint-disable-next-line no-unused-vars
export default {
  components: {
    ModalForm,
    MenuFilterSearchTable,
    MenuFilter,
    BaseDataTable,
    ModalPercentualRateio,
  },
  filters: {
    formataDescricao: (value) => {
      value = value.replace(/\?/g, "Ã");
      value = toTitle(value.toLowerCase());

      return value;
    },

    limitaDescricao: (value) => {
      if (value.length >= 70) {
        value = `${value.substr(0, 70)}...`;
      }
      return value;
    },
  },
  data() {
    return {
      dialogConsultaPercentual: false,
      labelBtn: "",
      dialog: false,
      loading: false,
      search: "",
      itemsServices: [],
      selectedService: {},
      filter: {},
      lastPage: 1,
      currentPage: 1,
      headers: [
        {
          text: "Serviço",
          align: "start",
          sortable: true,
          value: "descricao",
          filterable: true,
        },
        {
          text: "Cod nat. rend. PJ",
          align: "center",
          sortable: false,
          value: "cod_nat_rend_pj",
          filterable: false,
        },
        {
          text: "Cód. Tributação Municipal",
          align: "center",
          value: "cod_tributacao_municipio",
          filterable: true,
        },
        {
          text: "Cód. Contabilização Padrão",
          align: "center",
          value: "cod_contabilizacao_padrao",
          filterable: true,
        },
        {
          text: "Cód. IRRF",
          align: "center",
          value: "codigo_irrf",
          filterable: true,
        },
        { text: "Ações", align: "center", value: "action" },
      ],
    };
  },

  watch: {
    filter(value) {
      this.fetchServices(value);
    },
  },

  methods: {
    openConsultaPercentual(item) {
      this.dialogConsultaPercentual = true;
      this.selectedService = item;
    },
    updateFilter(event) {
      this.filter = { ...this.filter, ...event };
    },
    openModal() {
      this.dialog = true;
      this.labelBtn = "Cadastrar";
      if (this.$refs.mainModal.$refs.formServices)
        this.$refs.mainModal.$refs.formServices.reset();
    },
    openModalEdit(item) {
      this.dialog = true;
      this.labelBtn = "Editar";
      this.selectedService = item;
    },

    async closeModal() {
      this.dialog = false;
      await this.fetchServices(this.filter);
    },

    async fetchServices(filters) {
      try {
        this.loading = true;
        let { data } = await servicosPrestados().show({
          ...filters,
          per_page: 8,
        });
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        this.itemsServices = data.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async deleteService(item) {
      let res = await this.$swal({
        title: `Deseja apagar o serviço ${item.descricao}?`,
        text: "Isso não pode ser desfeito",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, apagar o serviço",
        cancelButtonText: "Cancelar",
      });
      if (!res.isConfirmed) return;
      try {
        await servicosPrestados(item.id).delete();
        toast("success", "Serviço removido");
      } catch (err) {
        toast("error", "Erro inesperado");
      } finally {
        this.fetchServices(this.filter);
      }
    },
  },
  created() {
    this.fetchServices();
  },
};
</script>
<style>
/* tbody tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.05);
} */
thead {
  background-color: #eef2f7;
}
.header {
  color: #ebffeb;
}

.filter-text {
  color: #707070;
}
d .v-label {
  font-size: 12px !important;
}
</style>
